import { largeLevelFontSizes, smallLevelFontSizes } from '../constants/heading-sizes.js';
import { FontWeight, LineHeight } from '../ContentText/types.js';
import { px2rem } from '../utils/helpers/style.js';

var defaultLevelBottomMargins = [px2rem(24), px2rem(24), px2rem(24), px2rem(16), px2rem(16)];
var headingAttributesWeb = {
  font: {
    weight: FontWeight.regular,
    lineHeight: LineHeight.normal
  },
  overrides: {
    large: {},
    small: {
      5: {
        weight: FontWeight.bold
      }
    }
  },
  levelFontSizes: {
    large: largeLevelFontSizes,
    small: smallLevelFontSizes
  },
  levelBottomMargins: defaultLevelBottomMargins
};
var headingThemeWeb = headingAttributesWeb;
var headingThemeNative = {
  font: {
    weight: FontWeight.regular,
    lineHeight: LineHeight.normal
  },
  levelFontSizes: largeLevelFontSizes,
  levelBottomMargins: defaultLevelBottomMargins
};

export { defaultLevelBottomMargins, headingAttributesWeb, headingThemeNative, headingThemeWeb };
